<template>
    <v-row align="center">
        <v-col>
            <v-text-field :label="label" v-model="email1" v-bind="inputProps" />
        </v-col>
        @
        <v-col>
            <v-text-field v-model="email2" v-bind="inputProps" />
        </v-col>
    </v-row>
</template>

<script>
const inputProps = {
    outlined: true,
    dense: true,
    "hide-details": true,
    persistentPlaceholder: true,
    class: "rounded-0",
};
export default {
    props: ["value", "label"],
    computed: {
        email() {
            return [this.email1, this.email2].join("@");
        },
    },
    data() {
        return {
            email1: null,
            email2: null,
            inputProps,
        };
    },
    methods: {
        init() {
            [this.email1, this.email2] = this.value.split("@");
        },
        sync() {
            this.$emit("input", this.email);
        },
    },
    mounted() {
        if (this.value) this.init();
    },
    watch: {
        value() {
            if (this.value !== this.email) this.init();
        },
        email() {
            if (this.value !== this.email) this.sync();
        },
    },
};
</script>

<style></style>
